import { styled } from '@mui/material';

export const StrikeThrough = styled('span')({
  textDecoration: 'line-through',
});
